var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.675,
    height: 11.783,
    viewBox: "0 0 17.675 11.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M17.568,9.944A9.842,9.842,0,0,0,8.837,4.5,9.843,9.843,0,0,0,.107,9.944a.993.993,0,0,0,0,.9,9.842,9.842,0,0,0,8.731,5.444,9.843,9.843,0,0,0,8.731-5.444A.993.993,0,0,0,17.568,9.944ZM8.837,14.81a4.419,4.419,0,1,1,4.419-4.419A4.419,4.419,0,0,1,8.837,14.81Zm0-7.364a2.925,2.925,0,0,0-.777.116A1.468,1.468,0,0,1,6.008,9.615a2.939,2.939,0,1,0,2.83-2.169Z",
    transform: "translate(0 -4.5)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeEye);
export default __webpack_public_path__ + "static/media/Icon awesome-eye.736ef9454ffb45c52b2130ea337c5204.svg";
export { ForwardRef as ReactComponent };